import React from 'react';
import './PageNotFound.css';
import { Button } from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { authService } from '../../api/authApi';
import { clearAuth } from '../../_redux/AuthSlice';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';
import { persistor, resetStore } from '../../store';

const PageNotFound = ({ error, resetErrorBoundary }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  console.log(error);

  const handleGoHome = async () => {
    try {
      await authService.logout();
    } catch (err) {
      console.error('Logout error:', err);
    } finally {
      dispatch(clearAuth());
      Cookies.remove('userName');
      Cookies.remove('userPassword');
      Cookies.remove('AccessToken');
      dispatch(resetStore());
      await persistor.flush();
      await persistor.purge();
      localStorage.clear();
      sessionStorage.clear();
      navigate('/ats/login');
      window.location.reload();
    }
  };

  return (
    <div className="pageNotfound">
      <div className="pageNotfoundContent">
        <img
          src={process.env.PUBLIC_URL + '/assests/img/pagenotfound.png'}
          width="800px"
        />
        <h1>Page Not Found </h1>
        <p>{error?.message ? error.message : ''}</p>
        {window.location.pathname !== '/layout/unsubscribe' && (
          <Button
            variant="contained"
            className="saveerror"
            onClick={handleGoHome}
          >
            Home
          </Button>
        )}
      </div>
      <div className="corners"></div>
    </div>
  );
};

export default PageNotFound;
